import { render, staticRenderFns } from "./PricePanelViewAssets.vue?vue&type=template&id=3112fa74&scoped=true"
import script from "./PricePanelViewAssets.vue?vue&type=script&lang=js"
export * from "./PricePanelViewAssets.vue?vue&type=script&lang=js"
import style0 from "./PricePanelViewAssets.vue?vue&type=style&index=0&id=3112fa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112fa74",
  null
  
)

export default component.exports